import script from "./LandingPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./LandingPage.vue?vue&type=script&lang=ts&setup=true"

import "./LandingPage.vue?vue&type=style&index=0&id=2dd9607e&lang=scss&scoped=true"

import exportComponent from "/Users/BlackPaw/Developer/acebed_vue3_web/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2dd9607e"]])

export default __exports__